// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2UnHx","rootCenter":"LoadMoreObserver_rootCenter__1aCk-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__14WRv"};